import { __assign } from "tslib";
export var textsApiRelativePath = "/helpcenter/texts";
export var textDefaultsApiRelativePath = "/apps/helpcenter/translations";
export var hcTextsApiRelativePath = '/helpcenter';
export var createTextsApi = function (baseUrl, http) {
    var apiUrl = "".concat(baseUrl).concat(textsApiRelativePath);
    var hcApiUrl = "".concat(baseUrl).concat(hcTextsApiRelativePath);
    return {
        getTextOverrides: function (dto) {
            return http.get("".concat(apiUrl, "/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        updateTextOverrides: function (dto) {
            return http.post("".concat(apiUrl, "/").concat(dto.locale), dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data);
        },
        getHCTextDefaults: function (dto) {
            return http.get("".concat(dto.tenantDefaultHost).concat(textDefaultsApiRelativePath, "/").concat(dto.locale).concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        getCustomTexts: function (dto) {
            return http.get("".concat(hcApiUrl, "/").concat(dto.locale, "/contentAndStructure/customKeys").concat(dto.brandId ? "?brandId=".concat(dto.brandId) : ''));
        },
        updateCustomTexts: function (dto) { return http.post("".concat(hcApiUrl, "/").concat(dto.locale, "/contentAndStructure/customKeys"), dto.brandId ? __assign(__assign({}, dto.data), { brandId: dto.brandId }) : dto.data); },
    };
};
//# sourceMappingURL=index.js.map